import React from 'react';
import { useRequestStatus } from '../contexts/RequestStatusContext';

export default function RequestStatusBar() {
  const { status } = useRequestStatus();

  if (!status) return null;

  return (
    <div
      className={`request-toast request-toast--${status.type}`}
      role="status"
      aria-live="polite"
    >
      {status.message}
    </div>
  );
}
